import React, { PropsWithChildren } from 'react';

// eslint-disable-next-line react/jsx-no-useless-fragment
const ChildrenComponent = ({ children }: PropsWithChildren) => <>{children}</>;
const ChildrenAggressiveMemo = React.memo(ChildrenComponent, () => true);

export default ChildrenAggressiveMemo;
